export const lang = {
  lang: 'EN',
  home: 'Home'
}



// WEBPACK FOOTER //
// ./src/assets/lang/en.js